var React = require('react');

function ButtonSlice (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M52.7357,0.0705L0,0v123.2335c6.061-0.757,11.5931-4.0227,15.1647-9.1064l56.0161-89.2549 C78.2703,13.5806,68.2817,0.1635,52.7357,0.0705z"}));
}

ButtonSlice.defaultProps = {"preserveAspectRatio":"none","focusable":"false","viewBox":"0 0 73.5037 123.2335"};

module.exports = ButtonSlice;

ButtonSlice.default = ButtonSlice;
